import { Form, Input, Select } from 'antd';
import React, { FC, ReactNode } from 'react';
import { STATES } from '../../constants/address';
import { StepSection } from '../StepPanel';

const { Option } = Select;

type Props = {
  title: string;
  addressKey: string;
  isAllFieldsRequired?: boolean;
  postcodeHint?: ReactNode;
};

const AddressFormSection: FC<Props> = ({
  title, addressKey, isAllFieldsRequired, postcodeHint,
}) => (
  <StepSection>
    <h3>{title}</h3>
    <Form.Item required={isAllFieldsRequired} label="Street address" name={[addressKey, 'streetAddress']} rules={[{ required: isAllFieldsRequired, message: 'Please enter your street address.' }]}>
      <Input autoComplete="street-address" />
    </Form.Item>
    <div className="grid2">
      <Form.Item required={isAllFieldsRequired} label="Suburb or town" name={[addressKey, 'suburb']} rules={[{ required: isAllFieldsRequired, message: 'Please enter your suburb or town.' }]}>
        <Input autoComplete="address-level2" />
      </Form.Item>
      <Form.Item label="State" required={isAllFieldsRequired} name={[addressKey, 'state']} rules={[{ required: isAllFieldsRequired, message: 'Please choose your state.' }]}>
        <Select placeholder="Please select state" style={{ width: '100%' }}>
          {STATES.map(({ value, label }) => (
            <Option value={value} key={value}>
              {label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Postcode"
        name={[addressKey, 'postcode']}
        required={isAllFieldsRequired}
        extra={postcodeHint}
        rules={[
          { required: isAllFieldsRequired, message: 'Please enter your postcode.' },
          {
            pattern: /^(\d{4})$/,
            message: 'Please enter a 4-digit postcode.',
          },
        ]}
      >
        <Input inputMode="numeric" maxLength={4} autoComplete="postal-code" style={{ width: '100%' }} />
      </Form.Item>
    </div>
  </StepSection>
);

export default AddressFormSection;
